import { Modal } from 'antd';

import { DOC_CHAT } from '../../Constants/commonConstants';
import AppButton from '../UI/AppButton/AppButton';

const docChatFaqs = [
  {
    q: 'How to upload documents and use Mike DocChat?',
    a: 'Click or Drag & Drop to Upload up to 50 files into the upload area. Type your question in “Ask DocChat” (in the upload area), or Click Start DocChat, then ask your question in the chat input. Once the upload is complete, your document(s) will appear in the document list on the left.',
  },
  {
    q: 'What file types can I upload?',
    a: 'You can upload Word documents and PDF files, including scanned PDFs, in Mike DocChat.',
  },
  {
    q: 'What is “Your Workflow” and how to use it?',
    a: 'Workflows let you run your own pre-defined prompts. Create and save custom extraction prompts as workflows to extract required data from one or multiple documents uploaded. To create your own workflow, go to Profile > Settings > Workflows > Create New Workflow. You can also click Create New Workflow in the Chat Window - it will redirect you to Settings to complete the same setup. In the home page, click Your Workflows and choose a workflow from the dropdown to run your custom extraction prompt.',
  },
  {
    q: 'How to use MikeLegal’s Magic?',
    a: 'Once you upload your document(s), click MikeLegal’s Magic from the dropdown and choose an Action, then click Start DocChat. This runs ready-made workflows created by us to extract selected contract data. Once the extraction is complete, you can export the results to Excel. This can be selected from the chat input or chat window as well.',
  },
  {
    q: 'Where do I see my document limit?',
    a: 'You can see your remaining document limit at the top right of the dashboard, next to your profile name. It shows the number of documents left.',
  },
];

const docCompareFaqs = [
  {
    q: 'How to use Mike DocCompare?',
    a: 'Click or drag & drop up to 6 files into the upload area. Then click “Start Comparing” to generate and view the results. Once the comparison is complete, your previous comparisons will appear in the comparison list on the left. Simply click any comparison to open and view it.',
  },
  {
    q: 'What file types can I upload?',
    a: 'You can upload Word documents and PDF files, including scanned PDFs in Mike DocCompare.',
  },
  {
    q: 'What does each filter option mean?',
    a: (
      <>
        <strong>Compare Across (All Documents):</strong> Shows contextual deviations across all
        uploaded documents.
        <br />
        <strong>View Internal Contradictions (Select a document):</strong> Shows internal
        contradictions within the selected document.
      </>
    ),
  },
  {
    q: 'How to export the results?',
    a: 'Go to Export at the top right of the tool (above the results). It lets you export the contextual deviations across documents and within each document into a single excel sheet making it easier to review, track changes, and share with your team.',
  },
  {
    q: 'Where do I see my comparison limit?',
    a: 'You can see your remaining comparison limit at the top right of the dashboard, next to your profile name. It shows the number of comparisons left.',
  },
];

function FAQ({ isOpen, onClose, product }) {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      style={{ top: '5%' }}
      width={900}
      footer={[
        <AppButton key='submit' type='primary' onClick={onClose}>
          Ok
        </AppButton>,
      ]}
    >
      <main className='faq-main'>
        <h2>Frequently Asked Questions</h2>
        <p className='fs-14 color-n9'>
          Quick answers to questions you may have. Can&apos;t find what you&apos;re looking for?
          Reach us out at{' '}
          <a href='mailto:team@mikelegal.com' className='color-primary'>
            team@mikelegal.com
          </a>
        </p>
        <ul className='mt-24'>
          {(product === DOC_CHAT ? docChatFaqs : docCompareFaqs).map(({ q, a }) => (
            <li key={q} className='mb-24'>
              <h4 className='fs-16'>{q}</h4>
              <div className='fs-14 color-n8'>{a}</div>
            </li>
          ))}
        </ul>
      </main>
    </Modal>
  );
}

export default FAQ;
